import { owcTheme } from 'core/theme/theme.config';
import { TypographyBody2, TypographySubtitle1, TypographySubtitle2 } from 'commons/components';
import styled from 'styled-components';

export const TrainingProgramCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const TrainingProgramSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const TrainingProgramSectionMeta = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TrainingProgramMainTitle = styled(TypographySubtitle2)`
    color: ${owcTheme['one-color-foreground-intensity-medium']} !important;
`;

export const TrainingProgramSectionTitle = styled(TypographySubtitle2)`
    color: ${owcTheme['one-color-foreground-intensity-high']} !important;
`;

export const TrainingProgramSectionDescription = styled(TypographyBody2)`
    color: ${owcTheme['one-color-foreground-intensity-medium']} !important;
`;

export const TrainingProgramSectionElements = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TrainingProgramElementLabel = styled(TypographySubtitle1)`
    color: ${owcTheme['one-color-foreground-intensity-high']} !important;
`;

export const TrainingProgramTaskTypeRow = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
`;
